// The shape of an External Link Page's cover image: portrait 3:4 (width : height).
// ONE constant for every place the cover is drawn - the public page, the form's preview, the detail
// panel and the list thumbnail - so they always show the same crop. A picture of another shape is not
// rejected: it is cropped around its middle (object-fit: cover), and the form's preview shows that crop
// before anything is saved.
export const LINK_COVER_ASPECT = '3 / 4';

// A good source size to hand a designer (3:4): the page shows it at most ~420 px wide.
export const LINK_COVER_BEST_SIZE = '1200 × 1600';
